<main>
    <table class="profil_table" *ngIf="isUserClassesEmpty == false; else noClassesContainer">
        <tr>
            <th>Nom de classe</th>
            <th>Code de classe</th>
            <th>Nombre d'Étoiles</th>
            <th>Actions</th>
        </tr>
        <tr *ngFor="let classe of userClasses | async">
            <td>{{classe.nom}}</td>
            <td>{{classe.code_ref}}</td>
            <td>{{classe.medailles_count.toFixed(1)}}</td>
            <td>
              <mat-icon style="cursor: pointer;" (click)="this.app.navigateTo('/classe/'+ classe.code_ref)" aria-hidden="false" aria-label="voir plus">add</mat-icon>
            </td>
        </tr>
    </table>
    <ng-template #noClassesContainer>
      <p *ngIf="userType == 'participant'">
        <i>Votre compte n'appartient pas encore à une classe.<br>Cliquez sur "Rejoindre une classe" et entrez le code donné par votre enseignant(e).</i>
      </p>
      <p *ngIf="userType == 'enseignant'">
        <i>Vous avez créer aucune classe pour l'instant.<br>Cliquez sur "ajouter une classe" en bas pour créer une classe.</i>
      </p>
    </ng-template>
</main>